"use client";

import { graphql, prefetch, useQuery } from "@opensea/graphql";
import { useState } from "react";
import { OfferAggregateTotalsFragment } from "@/components/offers/collection/OfferAggregateTotals.fragment";
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment";
import { useCollectionOfferTotalsSubscription } from "./use-collection-offer-totals-subscription";
const useCollectionOfferTotalsQuery = graphql(`
    query useCollectionOfferTotalsQuery(
      $collectionSlug: String!
      $filter: CollectionOffersFilter!
    ) {
      collectionOfferAggregatesTotal(
        collectionSlug: $collectionSlug
        filter: $filter
      ) {
        totalOffers
        totalValue {
          ...TokenPrice
          token {
            unit
          }
        }
        maxValueInTick {
          token {
            unit
          }
        }
        ...OfferAggregateTotals
      }
    }
  `, [TokenPriceFragment, OfferAggregateTotalsFragment]);
export function useCollectionOfferTotals({
  collectionSlug,
  filter
}) {
  const [{
    data
  }] = useQuery({
    query: useCollectionOfferTotalsQuery,
    variables: {
      collectionSlug,
      filter
    }
  });
  const [collectionOfferTotal, setCollectionOfferTotal] = useState();
  useCollectionOfferTotalsSubscription({
    variables: {
      collectionSlug
    },
    setCollectionOfferTotal: result => {
      setCollectionOfferTotal(data?.collectionOfferAggregatesTotal ? {
        ...data.collectionOfferAggregatesTotal,
        ...result
      } : undefined);
    }
  });
  return collectionOfferTotal ?? data?.collectionOfferAggregatesTotal;
}
export const prefetchUseCollectionOfferTotalsQuery = (collectionSlug, client) => {
  prefetch(client, useCollectionOfferTotalsQuery, {
    collectionSlug,
    filter: {}
  });
};